import React from 'react';
import { Edit3, Trash2, Globe, ExternalLink } from 'lucide-react';

export default function LandingPageRow({ page, onEdit, onDelete }) {
  return (
    <div className="bg-white rounded-lg border border-saffron-100/50 p-4 flex items-center gap-4" data-testid={`lp-${page.slug}`}>
      <Globe size={16} className="text-saffron flex-shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="font-sans font-semibold text-earth-dark text-sm">{page.country}</h3>
          {!page.published && <span className="text-[9px] bg-yellow-100 text-yellow-600 px-1.5 py-0.5 rounded font-sans font-semibold">DRAFT</span>}
        </div>
        <p className="text-[10px] text-earth/40 font-sans">/market/{page.slug}</p>
        <p className="text-xs text-earth/50 font-sans truncate mt-0.5">{page.meta_title}</p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <a href={`/market/${page.slug}`} target="_blank" rel="noopener noreferrer" className="text-[10px] font-sans text-saffron hover:text-saffron-dark flex items-center gap-0.5" data-testid={`lp-view-${page.slug}`}><ExternalLink size={10} /> View</a>
        <button onClick={() => onEdit(page)} className="text-[10px] font-sans text-saffron font-semibold hover:text-saffron-dark px-2 py-1" data-testid={`lp-edit-${page.slug}`}><Edit3 size={11} /></button>
        <button onClick={() => onDelete(page.slug)} className="text-red-400 hover:text-red-600" data-testid={`lp-delete-${page.slug}`}><Trash2 size={12} /></button>
      </div>
    </div>
  );
}
